/** Human elbow decisions ride the baked pivot through export. Unlike head seating,
 * this marker suppresses a repeated diagnostic; it does not reapply displacement.
 * The total offset is in the original joint bind frame, in world distance units.
 */
import { z } from 'zod';
import { readPoqpoqExtra, withPoqpoqExtra } from './poqpoq-extras.js';
const markerSchema = z.object({
  version: z.literal(1),
  provenance: z.literal('explicit'),
  source: z.string().min(1),
  totalOffset: z.object({ x: z.number().finite(), y: z.number().finite(), z: z.number().finite() }),
});
export type ElbowPlacementMarker = z.infer<typeof markerSchema>;
export function parseElbowPlacementMarker(
  data: unknown,
  where: string,
): ElbowPlacementMarker | null {
  const raw = readPoqpoqExtra(data, 'elbowPlacement');
  if (raw === undefined) return null;
  const parsed = markerSchema.safeParse(raw);
  if (!parsed.success)
    throw new Error(`${where}: malformed extras.poqpoq.elbowPlacement: ${parsed.error.message}`);
  return parsed.data;
}
export function withElbowPlacementMarker(
  data: unknown,
  marker: ElbowPlacementMarker,
): Record<string, unknown> {
  return withPoqpoqExtra(data, 'elbowPlacement', markerSchema.parse(marker));
}
